import React from 'react'
import { useSelector } from 'react-redux'
import { SelectWithData } from './SelectWithData'

export const EntityTypePicker = React.forwardRef((props, ref) => {
  const entityTypes = useSelector((state) => state.entityTypes.dataLite?.data)

  const { onEntityTypeSelected, currentEntityType } = props

  return (
    <SelectWithData
      {...props}
      dataRows={entityTypes}
      editable={props.mode !== 'view'}
      labelField={'label'}
      valueField={'id'}
      value={currentEntityType}
      onChangeText={onEntityTypeSelected}
    />
  )
})
